import * as React from "react";
import { Typography, Container } from "@mui/material";
import "./adminAria.css";
import question from "../../assets/Svgs/WhatWeDo1.svg";
import question2 from "../../assets/Svgs/WhatWeDo2.svg";
import WorkshopDel from "../../assets/images/workshop_del.png";
import PromiseDel from "../../assets/images/promise_del.png";
import CommunityMem from "../../assets/images/community_mem.png";
import AdminPanelPic from "../../assets/images/admin-panel-pic.png";
//import {AnimatePresence, motion} from 'framer-motion';
//import { useIsMobile } from "../../utils/mobileScreen";

const AdminAria = () => {
  //const isMobile = useIsMobile();
  return (
    <section>
      <Container className="admin-aria-container">
        <div className="admin-aria-box">
            <div>
                <img src={AdminPanelPic} />
            </div>
            <div className="admin-text-box">
                <Typography component="h2" className="techvanto-whyus-heading admin-heading-2">
                  Techvanto's Upskilling Platform
                </Typography>
                <Typography component="p" className="admin-aria-text">
                  Techvanto Academy provides some of the best job-oriented courses in Delhi,
                  carefully designed to prepare students for the real-world challenges of today’s 
                  competitive job market. Our courses focus not only on theoretical knowledge but 
                  also emphasize practical skills, hands-on training, and industry-relevant tools 
                  that help you become job-ready from day one. Whether you are a beginner looking
                  to start your career or a professional aiming to upgrade your skills, 
                  Techvanto Academy offers a wide range of programs tailored to meet your specific goals.
                  Our platform features a smart and customizable dashboard designed specifically for students, making 
                  learning more organized, efficient, and engaging. 
                </Typography>
            </div>
        </div>
      </Container>
    </section>
  );
};

export default AdminAria;
